export default __webpack_public_path__ + "static/media/partners-logo-duoback-w@3x.43efff69.webp";